import { render } from "./EscrowAccountTable.vue?vue&type=template&id=32b8c290&scoped=true"
import script from "./EscrowAccountTable.vue?vue&type=script&lang=js"
export * from "./EscrowAccountTable.vue?vue&type=script&lang=js"

import "./EscrowAccountTable.vue?vue&type=style&index=0&id=32b8c290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b8c290"]])

export default __exports__